import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import { useAssetContext } from 'src/hooks/useAssetContext';
import { AssetState, AssetStatus } from 'src/types';

const OPERATION_STATUSES = [
  AssetStatus.PENDING_UPLOAD,
  AssetStatus.PENDING_VALIDATION,
  AssetStatus.TRANSFORMATION_IN_PROGRESS,
];

export const useAssetOperationsInProgress = (assetType?: AssetType): boolean => {
  const { assetStates } = useAssetContext();

  if (assetType) {
    return OPERATION_STATUSES.includes(assetStates[assetType].status);
  }

  return Object.values(assetStates).some((asset: AssetState) =>
    OPERATION_STATUSES.includes(asset.status),
  );
};
